import { Injectable } from '@angular/core';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import Statsig from "statsig-js";


@Injectable({
  providedIn: 'root'
})
export class TagStatsigService {
 // private initialization;
   constructor() {
   }


 async initialize(){
    return await Statsig.initialize(
      environment.STATSIG_SDK_KEY,
      { userID: "3cFQfT58JnuE4gZslpeSrR" },
      { environment: { tier: environment.ENVIRONMENT_NAME },fetchMode:'cache-or-network'} // optional, pass options here if needed
    );
  }


  // get tagObject(){
  //   return Statsig;
  // }
}
